import { useHandleClickOutside } from '@/hooks/useHandleClickOutside'
import { Box, Input, Text } from '@chakra-ui/react'
import { format, parse } from 'BrokerTsLib/src/Utils/formatInputs'
import { useCallback, useEffect, useRef, useState } from 'react'
import { CustomEditableControls } from './CustomEditableControls'
import { EditableContext } from './EditableTinySelect'

type EditableNumberProps = {
  value?: number | string
  text?: string
  onSubmit: (limit: number) => void
  min?: number
  max?: number
  isDisabled?: boolean
  unit?: string
  errorMessage?: string
  editing?: boolean
}

export const EditablePriceCustom = ({ value, text, onSubmit, min, max, isDisabled, unit, errorMessage, editing = false }: EditableNumberProps) => {
  const [isEditing, setIsEditing] = useState(false)
  const [inputVal, setInputVal] = useState(format(value?.toString() || '') || '')

  useEffect(() => {
    setIsEditing(editing)
  }, [editing])

  // v pripade chyby chceme nechat editaci otevrenou
  useEffect(() => {
    if (errorMessage)
      setIsEditing(true)
  }, [!errorMessage])

  const submit = useCallback(() => {
    setIsEditing(false)
    onSubmit(inputVal ? parseInt(inputVal) : 0)
  }, [inputVal])

  const ref = useRef<HTMLInputElement>(null)
  useHandleClickOutside(ref, () => {
    submit()
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    const parsed = parse(value)

    setInputVal(parsed)
  }

  const textSx = { p: 0, fontSize: 'xs' }

  return (
    <EditableContext.Provider value={{
      isEditing: isEditing,
      setIsEditing: setIsEditing
    }}>
      <form onSubmit={(e) => {
        e.preventDefault()
        submit()
      }}>
        <Box sx={{ display: 'flex', gap: 1 }}>
          {!isEditing &&
            <Text sx={{ p: 0, fontSize: 'sm', color: errorMessage ? 'red.500' : '' }} >
              {text}
            </Text>
          }

          {isEditing &&
            <>
              {(!!min || min === 0) && (!!max || max === 0) && isEditing &&
                <Text sx={{ ...textSx }}>
                  {min}{unit} - {max}{unit}
                </Text>
              }

              <Input ref={ref}
                type='text'
                isInvalid={!!errorMessage}
                isDisabled={isDisabled}
                value={inputVal}
                onChange={handleChange}
                sx={{ w: 'auto', maxW: '100px', py: 0.25, bg: 'white', fontSize: 'sm', height: 'auto', lineHeight: '19px', textAlign: 'end' }}
              />
            </>
          }

          {!isDisabled && <CustomEditableControls />}
        </Box>
      </form>
    </EditableContext.Provider>
  )
}